// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: 'Roboto', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  top: 0 !important;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

@media print {
  @page {
    margin: 0;
  }

  body {
    margin: 1.6cm;
  }

  #print-btn {
    display: none;
  }
}

.clamp-1 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.clamp-2 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.clamp-3 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}


/* Default styling */
#sort {
  z-index: 1000;
  right: 5%;
  top: 3%;
  background-color: transparent;
  position: fixed;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: right;
  width: 72px;
  height: 60px;
}
#sort:active, #sort:hover{
  border: none;
  outline: none;
}

#sort option{
  font-size: 1.2rem;
  text-align: center;
}
/* Media query for smaller screens */
@media only screen and (max-width: 600px) {
  #sort {
    right: 13%; 
    top: 2.5%; 
  }
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EACE,SAAS;EACT,iCAAiC;EACjC,mCAAmC;EACnC,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE;aACW;AACb;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;AAC9B;;;AAGA,oBAAoB;AACpB;EACE,aAAa;EACb,SAAS;EACT,OAAO;EACP,6BAA6B;EAC7B,eAAe;EACf,4BAA4B;EAC5B,wBAAwB;EACxB,0BAA0B;EAC1B,WAAW;EACX,YAAY;AACd;AACA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA,oCAAoC;AACpC;EACE;IACE,UAAU;IACV,SAAS;EACX;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500&display=swap');\n\nbody {\n  margin: 0;\n  font-family: 'Roboto', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  top: 0 !important;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n@media print {\n  @page {\n    margin: 0;\n  }\n\n  body {\n    margin: 1.6cm;\n  }\n\n  #print-btn {\n    display: none;\n  }\n}\n\n.clamp-1 {\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 1;\n  -webkit-box-orient: vertical;\n}\n\n.clamp-2 {\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n}\n\n.clamp-3 {\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n}\n\n\n/* Default styling */\n#sort {\n  z-index: 1000;\n  right: 5%;\n  top: 3%;\n  background-color: transparent;\n  position: fixed;\n  background-repeat: no-repeat;\n  background-size: contain;\n  background-position: right;\n  width: 72px;\n  height: 60px;\n}\n#sort:active, #sort:hover{\n  border: none;\n  outline: none;\n}\n\n#sort option{\n  font-size: 1.2rem;\n  text-align: center;\n}\n/* Media query for smaller screens */\n@media only screen and (max-width: 600px) {\n  #sort {\n    right: 13%; \n    top: 2.5%; \n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
